import React from "react";
import { Translate } from "react-localize-redux";

interface BarberWaitTimeProps {
  queue: number;
}

const getColorClass = (queue: number): string => {
  if (queue === 0) return "wait-dot--green";
  if (queue < 30) return "wait-dot--yellow";
  if (queue <= 60) return "wait-dot--orange";
  return "wait-dot--red";
};

const BarberWaitTime: React.FC<BarberWaitTimeProps> = ({ queue }) => {
  const colorClass = getColorClass(queue);

  const displayText =
    queue === 0 ? <Translate id="general.timeNow" /> : `${queue} min`;

  return (
    <div className="c-wait-time">
      <span className="wait-time-text">{displayText}</span>
      <span className={`wait-dot ${colorClass}`} />
    </div>
  );
};

export default BarberWaitTime;
